import { render, staticRenderFns } from "./client-manager.vue?vue&type=template&id=c62a83fe&"
import script from "./client-manager.vue?vue&type=script&lang=js&"
export * from "./client-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports